<template>
  <div>
    <LogoImg/>
    <NavBar/>
    <NavMobile/>
    <GradientMap/>
    <MainBanner/>
    <IconText :blockContent="ourOffer"
              :buttonContent="button_0"/>
    <TextImgComponent :position="'text-img-component--img-right'"
                      :bgImg="'text-img-component--img-offer-2'"
                      :color="'text-img-component--grid-grey'"
                      :blockContent="block_1"
                      :buttonContent="button_1"/>
    <TextImgComponent :position="'text-img-component--img-left'"
                      :bgImg="'text-img-component--img-offer-1'"
                      :blockContent="block_2"
                      :buttonContent="button_2"/>
    <TextImgComponent :position="'text-img-component--img-right'"
                      :bgImg="'text-img-component--img-offer-3'"
                      :color="'text-img-component--grid-grey'"
                      :blockContent="block_3"
                      :buttonContent="button_3"/>
    <IconText :blockContent="interested"
              :buttonContent="button_bottom"/>
    <Footer/>
  </div>
</template>

<script>
import LogoImg from './LogoImg.vue'
// import MainBanner from './MainBanner.vue'
import NavBar from './NavBar.vue'
import GradientMap from './GradientMap.vue'
import TextImgComponent from './TextImgComponent.vue'
import IconText from './IconText.vue'
import Footer from './Footer.vue'
import NavMobile from './NavMobile.vue'


export default {
  name: 'PageOffer',
  components: {
    LogoImg,
    // MainBanner,
    NavBar,
    GradientMap,
    TextImgComponent,
    IconText,
    Footer,
    NavMobile
  },
  data () {
    return {
      ourOffer: {
        icon: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         width="150.000000pt" height="150.000000pt" viewBox="0 0 340.000000 227.000000"
         preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,227.000000) scale(0.100000,-0.100000)"
        fill="#e61919" stroke="none">
        <path d="M1410 1640 l-265 -149 0 -171 0 -172 275 -153 275 -153 70 40 c38 21
        85 46 103 55 17 9 32 19 32 22 0 3 -142 84 -315 180 -173 96 -315 177 -315
        181 0 3 24 18 53 34 l52 28 309 -173 c171 -94 318 -174 327 -176 18 -5 209 94
        209 108 0 3 -134 82 -299 173 -164 92 -306 172 -315 179 -14 10 -9 16 37 41
        l53 28 271 -151 c149 -83 274 -151 278 -151 3 0 4 52 3 116 l-3 116 -268 149
        c-147 82 -275 149 -285 148 -9 0 -136 -67 -282 -149z"/>
        <path d="M1142 904 l3 -116 268 -149 c147 -82 274 -149 282 -149 8 0 135 67
        282 149 l268 150 3 117 c2 105 1 116 -14 110 -9 -4 -133 -72 -275 -151 -143
        -80 -261 -145 -264 -145 -2 0 -126 68 -274 150 -148 83 -272 150 -276 150 -3
        0 -4 -52 -3 -116z"/>
        </g>
        </svg>`,
        paragraph: 'Nasza działalność skupia się na oferowaniu usług o charakterze gospodarczym i administracyjnym. Posiadamy dobrze rozbudowane zaplecze w postaci wózków widłowych, zatrudniamy wykwalifikowanych operatorów do ich obsługi. Ponadto zatrudniamy pracowników fizycznych do prac wspomagających oraz sprawną kadrę menedżerską. Dzięki temu możemy elastycznie dopasowywać ofertę do potrzeb klientów. Skupiamy się głównie na szeroko rozumianej obsłudze klientów z różnych branż. '
      },
      button_0: {
        url: '',
        label: ''
      },
      block_1: {
        headline: 'DO NASZYCH SZTANDAROWYCH USŁUG NALEŻĄ:',
        paragraph: '<ul><li>przygotowywanie i sortowanie opakowań zwrotnych do produkcji piwa,</li><li>usługi wspomagające produkcję i rozlewanie piwa,</li><li>obsługa na etapie tworzenia opakowań zbiorczych,</li><li>przewóz opakowań,</li><li>obsługa posprzedażowa – reklamacje i zwroty wyrobów gotowych.</li></ul>'
      },
      button_1: {
        url: '',
        label: ''
      },
      block_2: {
        headline: 'OFERUJEMY TEŻ INNE USŁUGI, NIEZWIĄZANE Z BRANŻĄ PIWOWARSKĄ',
        paragraph: '<ul><li>porządkowanie terenu wokół magazynów,</li><li>zagospodarowanie i utrzymanie terenów zielonych,</li><li>usługi porządkowe, w tym malowanie pasów,</li><li>prace pomocnicze przy produkcji,</li><li>przepakowywanie produktów,</li><li>kontrola produktów.</li></ul>'
      },
      button_2: {
        url: '',
        label: ''
      },
      block_3: {
        headline: 'JESTEŚMY OTWARCI NA POTRZEBY KLIENTÓW. OBOK SZEREGU USŁUG OFERUJEMY TEŻ:',
        paragraph: '<ul><li>wynajem wózka widłowego z operatorem,</li><li>obsługę aktywności przez operatora wózka widłowego i pracownika fizycznego,</li><li>transport samochodem ciężarowym.</li></ul>'
      },
      button_3: {
        url: '',
        label: ''
      },
      interested: {
        icon: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="150" height="150"
        	 viewBox="0 0 241.061 241.061" style="enable-background:new 0 0 241.061 241.061;" xml:space="preserve">
        <g>
        	<path style="fill:#e61919;" d="M198.602,70.402l-78.063,68.789l-78.08-68.79c-3.109-2.739-7.848-2.438-10.586,0.669c-2.737,3.108-2.439,7.847,0.67,10.586
        		l83.039,73.159c1.417,1.248,3.188,1.872,4.958,1.872s3.542-0.624,4.959-1.873l83.022-73.159c3.107-2.738,3.406-7.478,0.668-10.586
        		C206.449,67.964,201.711,67.664,198.602,70.402z"/>
        	<path style="fill:#e61919;" d="M218.561,38.529H22.5c-12.406,0-22.5,10.093-22.5,22.5v119.002c0,12.407,10.094,22.5,22.5,22.5h196.061
        		c12.406,0,22.5-10.093,22.5-22.5V61.029C241.061,48.623,230.967,38.529,218.561,38.529z M226.061,180.031
        		c0,4.135-3.364,7.5-7.5,7.5H22.5c-4.136,0-7.5-3.365-7.5-7.5V61.029c0-4.135,3.364-7.5,7.5-7.5h196.061c4.136,0,7.5,3.365,7.5,7.5
        		V180.031z"/>
        </g>
        </svg>`,
        paragraph: 'Zainteresowała Cię nasza oferta? Napisz do nas!'
      },
      button_bottom: {
        url: '/kontakt',
        label: 'SKONTATUJ SIĘ'
      }
    }
  }
}
</script>
